import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../../utils/seo';

export default function ContenusMultimediaPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mykinesiologue.ma';

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${siteUrl}/contenus-multimedia#webpage`,
    "url": `${siteUrl}/contenus-multimedia`,
    "name": "Contenus multimédia - MyKinesiologue Marrakech",
    "description": "Cet espace est dédié au partage progressif de contenus permettant d'approfondir la compréhension du corps, du stress et des mécanismes d'adaptation.",
    "isPartOf": {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F3EE]">
      <SEO
        title="Contenus multimédia - MyKinesiologue Marrakech"
        description="Cet espace est dédié au partage progressif de contenus permettant d'approfondir la compréhension du corps, du stress et des mécanismes d'adaptation."
        keywords="ressources kinésiologie, articles kinésiologie, podcasts bien-être, contenus stress Marrakech"
        canonical={`${siteUrl}/contenus-multimedia`}
        schema={schema}
      />

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-8 md:h-12" />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#1F1F1F] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} style={{ fontSize: '24px' }}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Accueil</Link>
            <Link to="/approche" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Approche</Link>
            <Link to="/a-qui-sadresse" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>À qui s'adresse</Link>
            <Link to="/presence" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Présence</Link>
            <Link to="/contenus-multimedia" className="text-[#1F4D45] font-semibold transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Contenus multimédia</Link>
            <Link to="/prendre-rendez-vous" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Prendre rendez-vous</Link>
            <Link to="/faq" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>FAQ</Link>
            <Link to="/prendre-rendez-vous#contact" className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-11 rounded-2xl flex items-center justify-center whitespace-nowrap hover:bg-[#1F4D45]/90 hover:translate-y-[-1px] transition-all duration-300 cursor-pointer ml-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px', fontWeight: '500' }}>Me contacter</Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#C9C1B8]">
            <div className="px-4 py-6 flex flex-col gap-4">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Accueil</Link>
              <Link to="/approche" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Approche</Link>
              <Link to="/a-qui-sadresse" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>À qui s'adresse</Link>
              <Link to="/presence" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Présence</Link>
              <Link to="/contenus-multimedia" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F4D45] font-medium transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Contenus multimédia</Link>
              <Link to="/prendre-rendez-vous" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Prendre rendez-vous</Link>
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>FAQ</Link>
              <Link to="/prendre-rendez-vous#contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-12 rounded-2xl flex items-center justify-center whitespace-nowrap cursor-pointer mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Me contacter</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 md:pt-48 pb-16 md:pb-24 bg-[#F7F3EE] relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/a801bb50ca09c34e0c07097cd0037f64.jpg" 
            alt="" 
            className="w-full h-full object-cover object-center opacity-30"
          />
        </div>
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 text-center relative z-10">
          <div className="inline-block border border-[#C9C1B8] rounded-full px-4 py-2 mb-6 md:mb-8 bg-[#F7F3EE]/80 backdrop-blur-sm">
            <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '13px' }}>Ressources et contenus</span>
          </div>
          <h1 className="text-[#1F1F1F] mb-4 md:mb-6 max-w-3xl mx-auto" style={{ fontFamily: 'Fraunces, serif', fontSize: '50px', lineHeight: '1.1', fontWeight: '600' }}>
            Contenus multimédia
          </h1>
          <p className="text-[#5E5A55] max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
            Cet espace est dédié au partage progressif de contenus permettant d'approfondir la compréhension du corps, du stress et des mécanismes d'adaptation.
          </p>
        </div>
      </section>

      {/* Content Formats Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-[#1F1F1F] mb-4" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
              Formats prévus
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* Articles */}
            <div className="bg-[#F7F3EE] rounded-2xl p-8 hover:shadow-lg transition-all duration-300 group cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center bg-[#1F4D45] rounded-full mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-article-line text-[#F7F3EE]" style={{ fontSize: '24px' }}></i>
              </div>
              <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                Articles
              </h3>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                Des réflexions écrites pour approfondir la compréhension du corps et des mécanismes d'adaptation au stress.
              </p>
            </div>

            {/* Podcasts */}
            <div className="bg-[#F7F3EE] rounded-2xl p-8 hover:shadow-lg transition-all duration-300 group cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center bg-[#1F4D45] rounded-full mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-mic-line text-[#F7F3EE]" style={{ fontSize: '24px' }}></i>
              </div>
              <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                Podcasts
              </h3>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                Des échanges audio pour explorer les thématiques du corps, de la régulation et de la kinésiologie.
              </p>
            </div>

            {/* Ressources */}
            <div className="bg-[#F7F3EE] rounded-2xl p-8 hover:shadow-lg transition-all duration-300 group cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center bg-[#1F4D45] rounded-full mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-folder-download-line text-[#F7F3EE]" style={{ fontSize: '24px' }}></i>
              </div>
              <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                Ressources
              </h3>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                PDF, audio et listes de lecture pour accompagner votre compréhension et votre pratique.
              </p>
            </div>

            {/* Réflexions et transmissions */}
            <div className="bg-[#F7F3EE] rounded-2xl p-8 hover:shadow-lg transition-all duration-300 group cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center bg-[#1F4D45] rounded-full mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-lightbulb-line text-[#F7F3EE]" style={{ fontSize: '24px' }}></i>
              </div>
              <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                Réflexions et transmissions
              </h3>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                Des partages autour du corps et de la régulation du stress, pour nourrir votre réflexion.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="py-16 md:py-24 bg-[#F7F3EE]">
        <div className="max-w-[800px] mx-auto px-4 md:px-8 text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-white rounded-full">
            <i className="ri-time-line text-[#1F4D45]" style={{ fontSize: '32px' }}></i>
          </div>
          <h2 className="text-[#1F1F1F] mb-4" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
            Contenus en préparation
          </h2>
          <p className="text-[#5E5A55] max-w-xl mx-auto mb-8" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
            Cette section sera progressivement enrichie de contenus variés pour approfondir votre compréhension du corps, du stress et des mécanismes d'adaptation.
          </p>
          <p className="text-[#5E5A55] max-w-xl mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
            En attendant, n'hésitez pas à me contacter pour toute question ou pour prendre rendez-vous.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-[900px] mx-auto px-4 md:px-8 text-center">
          <h2 className="text-[#1F1F1F] mb-4" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
            Une question sur l'approche ?
          </h2>
          <p className="text-[#5E5A55] mb-8 max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
            N'hésitez pas à me contacter pour échanger sur votre situation ou pour prendre rendez-vous.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/prendre-rendez-vous" className="bg-[#1F4D45] text-[#F7F3EE] px-8 h-12 rounded-2xl flex items-center justify-center whitespace-nowrap hover:bg-[#1F4D45]/90 hover:translate-y-[-1px] transition-all duration-300 cursor-pointer w-full sm:w-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px', fontWeight: '500' }}>
              Prendre rendez-vous
            </Link>
            <Link to="/faq" className="border-2 border-[#1F4D45] text-[#1F4D45] px-8 h-12 rounded-2xl flex items-center justify-center whitespace-nowrap hover:bg-[#1F4D45]/5 transition-all duration-300 cursor-pointer w-full sm:w-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px', fontWeight: '500' }}>
              Consulter la FAQ
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1F4D45] py-12 md:py-16">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <Link to="/" className="inline-block mb-4">
                <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-10" />
              </Link>
              <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                Kinésiologie à Marrakech
              </p>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Navigation
              </h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2">
                <Link to="/" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Accueil</Link>
                <Link to="/contenus-multimedia" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Contenus multimédia</Link>
                <Link to="/approche" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Approche</Link>
                <Link to="/prendre-rendez-vous" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Prendre rendez-vous</Link>
                <Link to="/a-qui-sadresse" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>À qui s'adresse</Link>
                <Link to="/faq" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>FAQ</Link>
                <Link to="/presence" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Présence</Link>
              </div>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Contact
              </h3>
              <div className="flex flex-col gap-2">
                <a href="mailto:contact@mykinesiologue.ma" className="text-[#F7F3EE] hover:underline break-all" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>contact@mykinesiologue.ma</a>
                <a href="tel:+212600000000" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>+212 6 00 00 00 00</a>
                <p className="text-[#E9E0D4] mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                  Marrakech, Maroc
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-[#F7F3EE]/20 pt-6 text-center">
            <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px' }}>
              © 2025 MyKinesiologue. Tous droits réservés.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
